const mapOffsetsToCamelCase = ({ offset_x, offset_y, ...obj }) => ({ ...obj, offsetX: offset_x, offsetY: offset_y });

export { mapOffsetsToCamelCase };
